import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  retrieveConnectionMarkersAirport,
  retrieveDirectMarkers,
  retrieveDirectMarkersAirport,
} from "../../api";
import { AppConfig } from "../../types";

interface FetchAllMarkersProps {
  requests: any;
  appConfig: AppConfig;
}

interface FetchMarkersProps {
  request: any;
  appConfig: AppConfig;
}

export const fetchMarkers = createAsyncThunk(
  "markers/fetchMarkers",
  async ({ requests, appConfig }: FetchAllMarkersProps, thunkAPI) => {
    let promises = [];
    if (requests.directMarkers) {
      promises.push(
        thunkAPI.dispatch(
          fetchDirectMarkers({
            request: requests.directMarkers.request,
            appConfig,
          })
        )
      );
    }
    if (requests.directMarkersAirport) {
      promises.push(
        thunkAPI.dispatch(
          fetchDirectMarkersAirport({
            request: requests.directMarkersAirport.request,
            appConfig,
          })
        )
      );
    }
    if (requests.connectionMarkersAirport) {
      promises.push(
        thunkAPI.dispatch(
          fetchConnectionMarkersAirport({
            request: requests.connectionMarkersAirport.request,
            appConfig,
          })
        )
      );
    }
    return await Promise.all(promises);
  }
);

export const fetchDirectMarkers = createAsyncThunk(
  "markers/fetchDirectMarkers",
  async ({ request, appConfig }: FetchMarkersProps, thunkAPI) => {
    return retrieveDirectMarkers(request, appConfig);
  }
);

export const fetchDirectMarkersAirport = createAsyncThunk(
  "markers/fetchDirectMarkersAirport",
  async ({ request, appConfig }: FetchMarkersProps, thunkAPI) => {
    return retrieveDirectMarkersAirport(request, appConfig);
  }
);

export const fetchConnectionMarkersAirport = createAsyncThunk(
  "markers/fetchConnectionMarkersAirport",
  async ({ request, appConfig }: FetchMarkersProps, thunkAPI) => {
    return retrieveConnectionMarkersAirport(request, appConfig);
  }
);
